import { render, staticRenderFns } from "./CommunicationGroupCreation.vue?vue&type=template&id=9f656004&scoped=true&"
import script from "./CommunicationGroupCreation.vue?vue&type=script&lang=js&"
export * from "./CommunicationGroupCreation.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationGroupCreation.vue?vue&type=style&index=0&id=9f656004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f656004",
  null
  
)

export default component.exports